var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 13,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 53,
    viewBox: "0 0 8.8 7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.125 7h6.5A1.125 1.125 0 0 0 8.75 5.875v-4.75A1.125 1.125 0 0 0 7.625 0h-6.5A1.125 1.125 0 0 0 0 1.125v4.75A1.125 1.125 0 0 0 1.125 7M.901.827A.4.4 0 0 1 1.125.75h6.5a.4.4 0 0 1 .224.077L4.375 3.29zm-.151.808 3.41 2.42a.4.4 0 0 0 .215.07.4.4 0 0 0 .215-.07L8 1.635v4.24a.38.38 0 0 1-.375.375h-6.5a.38.38 0 0 1-.375-.375z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export default ForwardRef;